import React, { FC } from 'react'
import { SidebarLogo } from './SidebarLogo'
import { SidebarProjects } from './SidebarProjects'
import { SidebarFooter } from './SidebarFooter'

const Sidebar = ({ current }) => {
  return (
    <div className="relative flex h-full flex-grow flex-col overflow-x-visible bg-white pt-2 pb-4">
      <div className="mt-4 flex flex-shrink-0 items-center justify-start px-4">
        <SidebarLogo />
      </div>

      <nav className="flex h-full flex-1 flex-col justify-between space-y-4 overflow-y-auto overflow-x-visible pb-8">
        <SidebarProjects />
      </nav>
      <footer className="flex flex-col items-center justify-center">
        <SidebarFooter />
      </footer>
    </div>
  )
}

export default Sidebar
